import React from "react";
import { useTranslation } from "react-i18next";
import { getDateString } from "util/common";
import { formatTierLabel } from "util/planEntitlements";
import styles from "./style.module.scss";

const PlanTierSummary = ({
  coreEntitlement,
  renewalDate,
  quotaRenewalHint,
  quotaCapacityHint,
  loading,
}) => {
  const { t } = useTranslation();
  const planName =
    coreEntitlement?.product_name ||
    coreEntitlement?.product_key ||
    t("settings.plan_unavailable");
  const isTrial = coreEntitlement?.status === "trial";

  return (
    <div className={styles.content}>
      <h3 className={styles.header}>{t("settings.plan_tier_summary_title")}</h3>
      {loading && !coreEntitlement ? (
        <p className={styles.sectionHint}>{t("settings.plan_loading")}</p>
      ) : (
        <>
          <div className={styles.tierSummaryHero}>
            <span className={styles.tierSummaryPlanName}>{planName}</span>
            {isTrial ? (
              <span className={styles.tierBadge}>{t("settings.plan_trial_badge")}</span>
            ) : coreEntitlement?.tier_key ? (
              <span className={styles.tierBadge}>{formatTierLabel(coreEntitlement.tier_key)}</span>
            ) : (
              <span className={styles.muted}>{t("settings.plan_tier_unknown")}</span>
            )}
          </div>
          <div className={styles.row}>
            <h5>{t("settings.127")}</h5>
            <h5>
              {coreEntitlement?.start_date
                ? getDateString(coreEntitlement.start_date)
                : t("settings.plan_unavailable")}
            </h5>
          </div>
          <div className={styles.row}>
            <h5>{t("settings.128")}</h5>
            <h5>
              {renewalDate
                ? getDateString(renewalDate)
                : coreEntitlement?.period_end
                  ? getDateString(coreEntitlement.period_end)
                  : t("settings.129")}
            </h5>
          </div>
        </>
      )}
      {quotaRenewalHint ? (
        <p className={styles.tierSummaryCaption}>{quotaRenewalHint}</p>
      ) : null}
      {quotaCapacityHint ? (
        <p className={styles.tierSummaryCaption}>{quotaCapacityHint}</p>
      ) : null}
    </div>
  );
};

export default PlanTierSummary;
